const styles = {
  container: '',
  list: 'flex flex-col gap-y-8 lg:gap-y-12',
};

export default styles;
